import React from "react";
import Nav from "./Nav";
import Footer from "./Footer";
import DatePicker from "./DatePicker";
import ReactPlayer from "./ReactPlayer";
import { Link } from "react-router-dom";
import { usersDataModal } from "../atoms/atom";
import { useRecoilState } from "recoil";

const Details = () => {
  const [data, setData] = useRecoilState(usersDataModal);
  console.log("checking data in details ===> ", data);

  return (
    <div>
      <Nav active="customerStories" />
      <div>
        <div
          // data-aos="fade-up"
          // data-aos-delay="200"
          // data-aos-duration="1000"
          className=" max-w-[800px] mx-auto px-5 pt-8 pb-20"
        >
          <h1 className="md:text-[43px] text-center text-[30px] font-bold md:leading-[60px] mb-8 leading-[40px] text-[#323a41] mt-3">
            {data.heading}
          </h1>
          <p className="mt-5 md:text-[23px] italic mx-auto text-[18px] leading-9 text-[#52626f]  opacity-80">
            {data.name}
          </p>
          <img
            src={require("../images/" + data.img)}
            alt=""
            className="max-h-[460px] my-8"
          />
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description1}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description2}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description3}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description4}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.li1}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.li2}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description5}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description6}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description7}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description8}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description9}
          </p>
          {data.italicLine1 && (
            <div>
              <hr className="h-[2px] mt-5 border-gray-700" />
              <hr className="border-gray-700" />
              <p className="mt-7 md:text-[22px] font-semibold italic  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-95">
                {data.italicLine1}
              </p>
              <p className="mt-5 md:text-[22px] font-semibold italic  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-95">
                {data.italicLine2}
              </p>
              <p className="mt-5 md:text-[22px] font-semibold italic  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-95">
                {data.italicLine3}
              </p>
              <div className="mt-6 text-center">
                <Link to="/category/case-studies">
                  <button className="md:py-4 md:px-6 p-3 m-1 text-xl font-semibold bg-[#f8cc84] hover:bg-[#e8c181] transition duration-200 ease-out text-[#323a41] text-center mx-auto">
                    Book a free consulting call!
                  </button>
                </Link>
              </div>
              <hr className="h-[2px] mt-9 border-gray-700" />
              <hr className="border-gray-700" />
            </div>
          )}
          <h1 className="md:text-[43px] text-[30px] font-semibold md:leading-[55px] mb-8 leading-[40px] text-[#323a41] mt-12">
            {data.heading2}
          </h1>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description10}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description11}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description12}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description13}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description14}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description15}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description16}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description17}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description18}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description19}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description20}
          </p>
          {data.url1 && (
            <div className="my-4">
              <ReactPlayer url={data.url1} />
            </div>
          )}
          <h1 className="md:text-[43px] text-[30px] font-semibold md:leading-[55px] mb-8 leading-[40px] text-[#323a41] mt-12">
            {data.heading3}
          </h1>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description21}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description22}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            <li>{data.li3}</li>
          </p>
          <p className="mt-1 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            <li>{data.li4}</li>
          </p>
          <p className="mt-1 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            <li>{data.li5}</li>
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description23}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description24}
          </p>
          <div>
            <h1 className="md:text-[43px] text-[30px] font-semibold md:leading-[55px] mb-8 leading-[40px] text-[#323a41] mt-12">
              {data.heading4}
            </h1>
            <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
              {data.description25}
            </p>
            <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
              {data.description26}
            </p>
            <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
              {data.description27}
            </p>
            <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
              {data.description28}
            </p>
            <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
              {data.description29}
            </p>
            <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
              {data.description30}
            </p>
          </div>
          {data.url2 && (
            <div className="my-4">
              <ReactPlayer url={data.url2} />
            </div>
          )}
          <h1 className="md:text-[43px] text-[30px] font-semibold md:leading-[55px] mb-8 leading-[40px] text-[#323a41] mt-12">
            {data.heading5}
          </h1>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description31}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description32}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description33}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description34}
          </p>
          <p className="mt-5 md:text-[22px]  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-80">
            {data.description35}
          </p>

          {data.italicLine4 && (
            <div>
              <div>
                <hr className="h-[2px] mt-5 border-gray-700" />
                <hr className="border-gray-700" />
                <p className="mt-7 md:text-[22px] font-semibold italic  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-95">
                  {data.italicLine4}
                </p>
                <p className="mt-5 md:text-[22px] font-semibold italic  mx-auto text-[18px] leading-8 text-[#52626f]  opacity-95">
                  {data.italicLine5}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
      <DatePicker />
      <Footer />
    </div>
  );
};

export default Details;
